import { render, staticRenderFns } from "./ArrayItemRemoveButton.vue?vue&type=template&id=79d6fcd2&"
import script from "./ArrayItemRemoveButton.vue?vue&type=script&lang=js&"
export * from "./ArrayItemRemoveButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports